import {
    SubstitutionFollowUpResponseDto,
    SubstitutionInquiryOfficeDetailsResponseDto,
    SubstitutionOverviewResponseDto,
} from '@/classes/dto/substitution-manager/overview/SubstitutionOverview.dto';
import {
    MakeupOfferPreviewResponseDto,
    MakeupOfferRequestResponseDto,
    MakeupOfferStatusItem,
    MakeupOfferWaitingResponseDto,
    PreviewMakeupOfferRequestDto,
    RequestMakeupOfferRequestDto,
} from '@/classes/dto/substitution-manager/makeup-offer/MakeupOffer.dto';
import {API, ApiRequestOptions} from '@/classes/api/api.class';
import {
    PreviewReaskWaitingListMailsRequestDto,
    SendReaskWaitingListRequestDto,
} from '@/classes/dto/substitution-manager/request/ReaskWaitingList.request.dto';
import {
    PreviewSubstitutionRequestMailsRequestDto,
    SendSubstitutionRequestsRequestDto,
} from '@/classes/dto/substitution-manager/request/SubstitutionRequestSend.dto';
import {MailDraftsPreviewResponseDto} from '@/classes/dto/_common/mail-review/MailDraft.dto';
import {MailReportResponseDto} from '@/classes/dto/_common/response/mailReport.response.dto';
import {
    FindSubstitutesRequestDto,
} from '@/classes/dto/substitution-manager/request/substitutes/FindSubstitutes.request.dto';
import {
    CreateSubstitutionInquiryRequestDto,
} from '@/classes/dto/substitution-manager/request/CreateSubstitutionInquiry.request.dto';
import {LeanDocument, Types} from 'mongoose';
import {
    FindSubstitutesResponseDto,
} from '@/classes/dto/substitution-manager/response/substitutes/FindSubstitutes.response.dto';
import {
    CheckBulkInquiriesForCourseCustomIdsResponseDto,
} from '@/classes/dto/substitution-manager/response/CheckBulkInquiriesForCourseCustomIds.response.dto';
import {
    CheckBulkInquiriesForCourseCustomIdsRequestDto,
} from '@/classes/dto/substitution-manager/request/CheckBulkInquiriesForCourseCustomIds.request.dto';
import {
    FindSubstitutionInquiryRequestDto,
} from '@/classes/dto/substitution-manager/request/FindSubstitutionInquiry.request.dto';
import {SubstitutionInquiryDocument} from '@/documentTypes/substitution-manager/SubstitutionInquiry.document';
import {FindByIdOptionsRequestDto} from '@/classes/dto/_common/request/FindByIdOptions.request.dto';
import {
    CancelSubstitutionInquiryRequestDto,
} from '@/classes/dto/substitution-manager/request/CancelSubstitutionInquiry.request.dto';
import {
    ReplaceConfirmedSubstituteRequestDto,
} from '@/classes/dto/substitution-manager/request/ReplaceConfirmedSubstitute.request.dto';
import {
    UpdateSubstitutionInquiryRequestDto,
} from '@/classes/dto/substitution-manager/request/UpdateSubstitutionInquiry.request.dto';
import {
    UpdateSubstituteConfirmationRequestDto,
} from '@/classes/dto/substitution-manager/request/UpdateSubstituteConfirmation.request.dto';
import {
    DeleteSubstitutionInquiryRequestDto,
} from "@/classes/dto/substitution-manager/request/DeleteSubstitutionInquiry.request.dto";
import {TakeoverOfferDocument} from '@/documentTypes/substitution-manager/TakeoverOffer.document';
import {TakeoverOfferSettings} from '@/documentTypes/substitution-manager/TakeoverOfferSettings.document';
import {
    CreateTakeoverOfferRequestDto,
} from '@/classes/dto/substitution-manager/takeover-offer/request/CreateTakeoverOffer.request.dto';
import {
    FindTakeoverOfferRequestDto,
} from '@/classes/dto/substitution-manager/takeover-offer/request/FindTakeoverOffer.request.dto';
import {
    FindTakeoverOfferResponseDto,
} from '@/classes/dto/substitution-manager/takeover-offer/response/FindTakeoverOffer.response.dto';
import {
    TakeoverOfferSummaryResponseDto,
} from '@/classes/dto/substitution-manager/takeover-offer/response/TakeoverOfferSummary.response.dto';
import {
    AddTakeoverOfferCandidatesRequestDto,
} from '@/classes/dto/substitution-manager/takeover-offer/request/AddTakeoverOfferCandidates.request.dto';
import {
    ResendTakeoverOfferRequestDto,
} from '@/classes/dto/substitution-manager/takeover-offer/request/ResendTakeoverOffer.request.dto';
import {
    RemindTakeoverOfferRequestDto,
} from '@/classes/dto/substitution-manager/takeover-offer/request/RemindTakeoverOffer.request.dto';
import {
    WithdrawTakeoverOfferRequestDto,
} from '@/classes/dto/substitution-manager/takeover-offer/request/WithdrawTakeoverOffer.request.dto';
import {
    TakeoverOfferConfirmPreviewResponseDto,
} from '@/classes/dto/substitution-manager/takeover-offer/response/TakeoverOfferConfirmPreview.response.dto';
import {
    ConfirmTakeoverOfferRequestDto,
} from '@/classes/dto/substitution-manager/takeover-offer/request/ConfirmTakeoverOffer.request.dto';
import {
    RejectTakeoverOfferAcceptanceRequestDto,
} from '@/classes/dto/substitution-manager/takeover-offer/request/RejectTakeoverOfferAcceptance.request.dto';
import {
    ReofferTakeoverOfferRequestDto,
} from '@/classes/dto/substitution-manager/takeover-offer/request/ReofferTakeoverOffer.request.dto';
import {
    UpdateTakeoverOfferSettingsRequestDto,
} from '@/classes/dto/substitution-manager/takeover-offer/request/UpdateTakeoverOfferSettings.request.dto';
import {
    TakeoverOfferLinkResponseDto,
} from '@/classes/dto/substitution-manager/takeover-offer/response/TakeoverOfferLink.response.dto';

/** Lean takeover offer as returned by the endpoints (populated fields depending on the request) */
export type LeanTakeoverOffer = LeanDocument<TakeoverOfferDocument>;
/** Wrapped answers: confirm {takeoverOffer, confirmResults, informedPreviousTeachers}, reject-acceptance / remind {takeoverOffer, …} */
export interface TakeoverOfferWrappedWriteResponse {
    takeoverOffer?: LeanTakeoverOffer;
    confirmResults?: LeanTakeoverOffer['confirmResults'];
    [key: string]: unknown;
}

/** Write endpoints answer with the changed offer, a wrapper around it or only its id (resolve with resolveOffer) */
export type TakeoverOfferWriteResponse = LeanTakeoverOffer | TakeoverOfferWrappedWriteResponse | Types.ObjectId | string | undefined;
import {
    BulkUpdateMakeupClaimStateRequestDto,
    BulkUpdateMakeupClaimStateResponseDto,
    FindMakeupClaimRequestDto,
    MakeupClaimSummaryItem,
    UpdateMakeupClaimRequestDto,
} from '@/classes/dto/substitution-manager/request/makeup-claim/MakeupClaim.request.dto';
import {MakeupClaim} from '@/documentTypes/substitution-manager/MakeupClaim.document';
import {
    CommitMakeupPlanRequestDto,
    CommitMakeupPlanResponseDto,
    GetMakeupSuggestionsRequestDto,
    MakeupPlanCheckResponseDto,
    MakeupSuggestionsResponseDto,
    MakeupPresenceNotifyPreviewResponseDto,
    MakeupPresenceNotifySendResponseDto,
    PreviewMakeupPresenceNotifyRequestDto,
    SendMakeupPresenceNotifyRequestDto,
} from '@/classes/dto/substitution-manager/request/makeup-presence/MakeupPresence.dto';

import {
    AddGoodwillMakeupRoundChildRequestDto,
    AutoPlanMakeupRoundRequestDto,
    LatePlanMakeupRoundRequestDto,
    CreateMakeupRoundRequestDto,
    EligibleMakeupRoundClaim,
    FinalizeMakeupRoundRequestDto,
    MakeupRoundFinalizeResponseDto,
    MakeupRoundListItem,
    MakeupRoundMessagePreviewResponseDto,
    MakeupRoundPullResponseDto,
    MakeupRoundRoomOption,
    MakeupRoundSaturdayOptionsResponseDto,
    MakeupRoundSendResponseDto,
    MakeupRoundTeacherSuggestion,
    MakeupRoundView,
    PreviewMakeupRoundMessagesRequestDto,
    SendMakeupRoundMessagesRequestDto,
    SetMakeupRoundReplyRequestDto,
    UpdateMakeupRoundGroupsRequestDto,
    UpdateMakeupRoundInvitationsRequestDto,
    UpdateMakeupRoundRequestDto,
} from '@/classes/dto/substitution-manager/makeup-round/MakeupRound.dto';
import {MakeupRoundState} from '@/enums/substitution-manager/MakeupRoundState';
import {
    PreviewCancellationMailsRequestDto,
    SendCancellationRequestDto,
} from '@/classes/dto/substitution-manager/request/CancellationMails.request.dto';

export class SubstitutionManagerApi extends API {
    static service = 'substitution-manager';
    static substitutes = {
        async find(data: FindSubstitutesRequestDto): Promise<FindSubstitutesResponseDto> {
            return SubstitutionManagerApi.get('substitutes/find', data);
        },
    }

    /**
     * Takeover offers ("Dauerhafte Übernahme anbieten"), module takeover-offers of the substitution-manager.
     * Never single-segment paths (the root controller has :id routes). Permission: SUBSTITUTION_INQUIRY.
     */
    static takeoverOffers = {
        /** options.handledStatuses [409]: "läuft bereits" is shown inline by the dialog (no global error dialog) */
        async create(data: CreateTakeoverOfferRequestDto, options?: ApiRequestOptions): Promise<TakeoverOfferWriteResponse> {
            return SubstitutionManagerApi.post('takeover-offers/create', data, undefined, options);
        },
        async find(data: FindTakeoverOfferRequestDto, options?: ApiRequestOptions): Promise<FindTakeoverOfferResponseDto> {
            return SubstitutionManagerApi.get('takeover-offers/find', data, undefined, options);
        },
        /** Counts per Standort (badge of the teacher card); 404 of older backends is handled by the caller */
        async summary(institutions: Types.ObjectId[]): Promise<TakeoverOfferSummaryResponseDto> {
            return SubstitutionManagerApi.get('takeover-offers/summary', {institutions}, undefined, {handledStatuses: [404]});
        },
        async findById(id: Types.ObjectId | string, options?: FindByIdOptionsRequestDto): Promise<LeanTakeoverOffer> {
            return SubstitutionManagerApi.get(`takeover-offers/by-id/${id}`, options);
        },
        async addCandidates(id: Types.ObjectId | string, body: AddTakeoverOfferCandidatesRequestDto, options?: ApiRequestOptions): Promise<TakeoverOfferWriteResponse> {
            return SubstitutionManagerApi.post(`takeover-offers/${id}/candidates`, body, undefined, options);
        },
        /** "Erneut senden": the running offer again to persons already in it (same message, fresh link); answers {resent, takeoverOffer} */
        async resend(id: Types.ObjectId | string, body: ResendTakeoverOfferRequestDto, options?: ApiRequestOptions): Promise<TakeoverOfferWriteResponse> {
            return SubstitutionManagerApi.post(`takeover-offers/${id}/resend`, body, undefined, options);
        },
        /** Without employees all pending candidates are reminded */
        async remind(id: Types.ObjectId | string, body: RemindTakeoverOfferRequestDto): Promise<TakeoverOfferWriteResponse> {
            return SubstitutionManagerApi.post(`takeover-offers/${id}/remind`, body);
        },
        async withdraw(id: Types.ObjectId | string, body: WithdrawTakeoverOfferRequestDto): Promise<TakeoverOfferWriteResponse> {
            return SubstitutionManagerApi.post(`takeover-offers/${id}/withdraw`, body);
        },
        /** Preview of the given weekdays (default: all accepted, if none the confirmed ones) */
        async confirmPreview(id: Types.ObjectId | string, days?: number[]): Promise<TakeoverOfferConfirmPreviewResponseDto> {
            return SubstitutionManagerApi.get(`takeover-offers/${id}/confirm-preview`, days?.length ? {days} : undefined);
        },
        /** "Bestätigen & eintragen" per weekday (days); also the retry of failed courses (onlyCustomIds) */
        async confirm(id: Types.ObjectId | string, body: ConfirmTakeoverOfferRequestDto): Promise<TakeoverOfferWriteResponse> {
            return SubstitutionManagerApi.post(`takeover-offers/${id}/confirm`, body);
        },
        /** Per weekday (days): the rejected weekdays are open again for the remaining candidates */
        async rejectAcceptance(id: Types.ObjectId | string, body: RejectTakeoverOfferAcceptanceRequestDto): Promise<TakeoverOfferWriteResponse> {
            return SubstitutionManagerApi.post(`takeover-offers/${id}/reject-acceptance`, body);
        },
        /** "Neu anbieten": clones an expired / withdrawn offer */
        async reoffer(id: Types.ObjectId | string, body: ReofferTakeoverOfferRequestDto, options?: ApiRequestOptions): Promise<TakeoverOfferWriteResponse> {
            return SubstitutionManagerApi.post(`takeover-offers/${id}/reoffer`, body, undefined, options);
        },
        /** Signed link of a candidate ("Link kopieren"); the first fetch is recorded as manual contact */
        async link(id: Types.ObjectId | string, employeeId: Types.ObjectId | string): Promise<TakeoverOfferLinkResponseDto> {
            return SubstitutionManagerApi.get(`takeover-offers/${id}/link/${employeeId}`);
        },
        /** 404 of older backends is handled by the caller (defaults are used then) */
        async getSettings(options?: ApiRequestOptions): Promise<Partial<TakeoverOfferSettings> | undefined> {
            return SubstitutionManagerApi.get('takeover-offers/settings', undefined, undefined, {
                handledStatuses: [404, ...(options?.handledStatuses || [])],
            });
        },
        async updateSettings(body: UpdateTakeoverOfferSettingsRequestDto): Promise<Partial<TakeoverOfferSettings> | undefined> {
            return SubstitutionManagerApi.put('takeover-offers/settings', body);
        },
    };

    /**
     * Nachholansprüche (newer backends only). Reads leave 403 (no right) / 404 (older backend) to the caller
     * (no global error dialog), the callers show nothing in that case.
     */
    static makeupClaims = {
        async find(data: FindMakeupClaimRequestDto): Promise<{ makeupClaims: MakeupClaim[]; maxPage: number }> {
            return SubstitutionManagerApi.get('makeup-claims/find', data, undefined, {handledStatuses: [403, 404]});
        },
        async summary(inquiries: Array<Types.ObjectId | string>): Promise<{ items: MakeupClaimSummaryItem[] }> {
            return SubstitutionManagerApi.get('makeup-claims/summary', {inquiries}, undefined, {handledStatuses: [403, 404]});
        },
        async update(id: Types.ObjectId | string, body: UpdateMakeupClaimRequestDto): Promise<Types.ObjectId> {
            return SubstitutionManagerApi.patch(`makeup-claims/${id}`, body);
        },
        async bulkState(body: BulkUpdateMakeupClaimStateRequestDto): Promise<BulkUpdateMakeupClaimStateResponseDto> {
            return SubstitutionManagerApi.post('makeup-claims/bulk-state', body);
        },
    }

    /**
     * Nachholtermin vor Ort (deliverable C). 409 (conflicts / blocked) and 422 are handled by the caller (shown in the
     * planner, no global error dialog).
     */
    static makeupPresence = {
        async suggestions(body: GetMakeupSuggestionsRequestDto): Promise<MakeupSuggestionsResponseDto> {
            return SubstitutionManagerApi.post('makeup-presence/suggestions', body, undefined, {handledStatuses: [403, 404, 409, 422, 503]});
        },
        async checkPlan(body: CommitMakeupPlanRequestDto): Promise<MakeupPlanCheckResponseDto> {
            return SubstitutionManagerApi.post('makeup-presence/plan/check', body, undefined, {handledStatuses: [403, 404, 409, 422, 503]});
        },
        async commitPlan(body: CommitMakeupPlanRequestDto): Promise<CommitMakeupPlanResponseDto> {
            return SubstitutionManagerApi.post('makeup-presence/plan', body, undefined, {handledStatuses: [403, 409, 422, 503]});
        },
        /** Elterninfo: recipients + rendered preview, nothing is sent */
        async notifyPreview(body: PreviewMakeupPresenceNotifyRequestDto): Promise<MakeupPresenceNotifyPreviewResponseDto> {
            return SubstitutionManagerApi.post('makeup-presence/notify/preview', body, undefined, {handledStatuses: [403, 404, 422]});
        },
        /** "Eltern benachrichtigen" (explicit send step, confirm: true) */
        async notifySend(body: SendMakeupPresenceNotifyRequestDto): Promise<MakeupPresenceNotifySendResponseDto> {
            return SubstitutionManagerApi.post('makeup-presence/notify', body, undefined, {handledStatuses: [403, 404, 422]});
        },
    }

    /**
     * Online-Nachholrunden (Samstag), custom key MANAGE_MAKEUP_ROUNDS. 409 (finalize: warnings to confirm / changed
     * meanwhile) and 422 (rule violated, text in the message) are left to the caller. Only messages.send sends anything.
     */
    static makeupRounds = {
        async find(data: { state?: MakeupRoundState[]; from?: Date; to?: Date } = {}): Promise<{ makeupRounds: MakeupRoundListItem[] }> {
            return SubstitutionManagerApi.get('makeup-rounds/find', data, undefined, {handledStatuses: [403, 404]});
        },
        async get(id: string): Promise<MakeupRoundView> {
            return SubstitutionManagerApi.get(`makeup-rounds/${id}`, undefined, undefined, {handledStatuses: [403, 404]});
        },
        async eligibleClaims(date?: Date): Promise<{ claims: EligibleMakeupRoundClaim[] }> {
            return SubstitutionManagerApi.get('makeup-rounds/eligible-claims', date ? {date} : {}, undefined, {handledStatuses: [403, 404]});
        },
        async teacherSuggestions(): Promise<{ teachers: MakeupRoundTeacherSuggestion[] }> {
            return SubstitutionManagerApi.get('makeup-rounds/teacher-suggestions', {}, undefined, {handledStatuses: [403, 404]});
        },
        async onlineRooms(): Promise<{ rooms: MakeupRoundRoomOption[] }> {
            return SubstitutionManagerApi.get('makeup-rounds/online-rooms', {}, undefined, {handledStatuses: [403, 404]});
        },
        async create(body: CreateMakeupRoundRequestDto): Promise<MakeupRoundView> {
            return SubstitutionManagerApi.post('makeup-rounds', body, undefined, {handledStatuses: [409, 422]});
        },
        async update(id: string, body: UpdateMakeupRoundRequestDto): Promise<MakeupRoundView> {
            return SubstitutionManagerApi.patch(`makeup-rounds/${id}`, body, {handledStatuses: [409, 422]});
        },
        async invitations(id: string, body: UpdateMakeupRoundInvitationsRequestDto): Promise<MakeupRoundView & { rejected: Array<{ claim: string; reason: string }> }> {
            return SubstitutionManagerApi.post(`makeup-rounds/${id}/invitations`, body, undefined, {handledStatuses: [409, 422]});
        },
        async reply(id: string, body: SetMakeupRoundReplyRequestDto): Promise<MakeupRoundView> {
            return SubstitutionManagerApi.post(`makeup-rounds/${id}/replies`, body, undefined, {handledStatuses: [409, 422]});
        },
        /** The 4 Saturdays offered to these children (same as the yes-page) – for "Ja vermerken" */
        async saturdayOptions(id: string, claims: string[]): Promise<MakeupRoundSaturdayOptionsResponseDto> {
            return SubstitutionManagerApi.get(`makeup-rounds/${id}/saturday-options`, {claims}, undefined, {handledStatuses: [403, 404, 422]});
        },
        /** "yes" children of other rounds that chose this Saturday move into this round */
        async pullChosen(id: string): Promise<MakeupRoundPullResponseDto> {
            return SubstitutionManagerApi.post(`makeup-rounds/${id}/pull-chosen`, {}, undefined, {handledStatuses: [409, 422]});
        },
        /** "Kind ohne Anspruch (Kulanz)": goodwill claim + "yes" for the round's Saturday; 409 {message, claim} = open claim exists */
        async goodwill(id: string, body: AddGoodwillMakeupRoundChildRequestDto): Promise<MakeupRoundView> {
            return SubstitutionManagerApi.post(`makeup-rounds/${id}/goodwill`, body, undefined, {handledStatuses: [409, 422]});
        },
        /** "Kind nachträglich einplanen" in a finalized round (lateOpen): existing group with course or new group */
        async latePlan(id: string, body: LatePlanMakeupRoundRequestDto): Promise<MakeupRoundView> {
            return SubstitutionManagerApi.post(`makeup-rounds/${id}/late-plan`, body, undefined, {handledStatuses: [409, 422]});
        },
        async autoPlan(id: string, body: AutoPlanMakeupRoundRequestDto = {}): Promise<MakeupRoundView> {
            return SubstitutionManagerApi.post(`makeup-rounds/${id}/auto-plan`, body, undefined, {handledStatuses: [409, 422]});
        },
        async groups(id: string, body: UpdateMakeupRoundGroupsRequestDto): Promise<MakeupRoundView> {
            return SubstitutionManagerApi.put(`makeup-rounds/${id}/groups`, body, {handledStatuses: [409, 422]});
        },
        async finalize(id: string, body: FinalizeMakeupRoundRequestDto): Promise<MakeupRoundFinalizeResponseDto> {
            return SubstitutionManagerApi.post(`makeup-rounds/${id}/finalize`, body, undefined, {handledStatuses: [409, 422]});
        },
        async cancel(id: string): Promise<MakeupRoundView> {
            return SubstitutionManagerApi.post(`makeup-rounds/${id}/cancel`, {}, undefined, {handledStatuses: [409, 422]});
        },
        async previewMessages(id: string, body: PreviewMakeupRoundMessagesRequestDto): Promise<MakeupRoundMessagePreviewResponseDto> {
            return SubstitutionManagerApi.post(`makeup-rounds/${id}/messages/preview`, body, undefined, {handledStatuses: [409, 422]});
        },
        /** Sends the parent messages – only from the explicit send step after the preview */
        async sendMessages(id: string, body: SendMakeupRoundMessagesRequestDto): Promise<MakeupRoundSendResponseDto> {
            return SubstitutionManagerApi.post(`makeup-rounds/${id}/messages/send`, body, undefined, {handledStatuses: [409, 422]});
        },
    }

    /**
     * "Online nachholen → Eltern sofort fragen". 403 / 409 / 422 are left to the caller. Only `request` leads to a send –
     * stored on the inquiry and sent once the course is really cancelled (right away if it already is).
     */
    static makeupOffers = {
        /** Online claims waiting for an offer (banner, menu counter); MANAGE_MAKEUP_ROUNDS */
        async waiting(): Promise<MakeupOfferWaitingResponseDto> {
            return SubstitutionManagerApi.get('makeup-offers/waiting', {}, undefined, {handledStatuses: [403, 404]});
        },
        async status(inquiries: string[]): Promise<{ items: MakeupOfferStatusItem[] }> {
            return SubstitutionManagerApi.get('makeup-offers/status', {inquiries}, undefined, {handledStatuses: [403, 404]});
        },
        async preview(body: PreviewMakeupOfferRequestDto): Promise<MakeupOfferPreviewResponseDto> {
            return SubstitutionManagerApi.post('makeup-offers/preview', body, undefined, {handledStatuses: [403, 404, 422]});
        },
        async request(inquiryId: string, body: RequestMakeupOfferRequestDto): Promise<MakeupOfferRequestResponseDto> {
            return SubstitutionManagerApi.post(`makeup-offers/inquiry/${inquiryId}`, body, undefined, {handledStatuses: [403, 404, 409, 422]});
        },
    }

    static async create(data: CreateSubstitutionInquiryRequestDto): Promise<Types.ObjectId> {
        return SubstitutionManagerApi.post('', data);
    }

    static async checkBulkInquiriesForCourseCustomIds(data: CheckBulkInquiriesForCourseCustomIdsRequestDto): Promise<CheckBulkInquiriesForCourseCustomIdsResponseDto> {
        return SubstitutionManagerApi.get('bulk/existing-inquiries-by-custom-id', data);
    }

    static async find(data: FindSubstitutionInquiryRequestDto): Promise<{
        substitutionInquiries: LeanDocument<SubstitutionInquiryDocument>[];
        maxPage: number;
        /** newer backends */
        total?: number;
    }> {
        return SubstitutionManagerApi.get('', data);
    }

    /** "Übersicht der Vertretungsanfragen": rows with situation, sorted by urgency, counts for the tiles (newer backends) */
    static async overview(data: FindSubstitutionInquiryRequestDto): Promise<SubstitutionOverviewResponseDto> {
        return SubstitutionManagerApi.get('overview', data);
    }

    /** Panel: sick report and the way of each asked teacher to the Standort */
    static async officeDetails(id: Types.ObjectId | string, employees: string[] = []): Promise<SubstitutionInquiryOfficeDetailsResponseDto> {
        return SubstitutionManagerApi.get(`${id}/office-details`, employees.length ? {employees} : undefined, undefined, {handledStatuses: [403, 404]});
    }

    /**
     * "Bestätigung senden": is the occasion "Vertretung bestätigt" set up? With employeeId: the channel this teacher gets
     * (whatsApp / mail / both) or why nothing would be sent (older services ignore the parameter: no channel)
     */
    static async confirmationReady(employeeId?: string): Promise<{ ready: boolean; text?: string; channel?: 'whatsApp' | 'mail' | 'both' }> {
        // plain query parameter (the controller reads @Query('employeeId'); `get(path, params)` would send ?json=…)
        const query = employeeId ? `?employeeId=${encodeURIComponent(employeeId)}` : '';
        return SubstitutionManagerApi.get(`confirmation-ready${query}`, undefined, undefined, {handledStatuses: [403, 404]});
    }

    /** "Weitere Lehrkräfte anfragen" / "Anfragen", review flow: mails of the new substitutes */
    static async previewAddSubstitutes(id: Types.ObjectId | string, body: PreviewReaskWaitingListMailsRequestDto): Promise<MailDraftsPreviewResponseDto> {
        return SubstitutionManagerApi.post(`${id}/add-substitutes/preview`, body, undefined, {handledStatuses: [422]});
    }

    /** "Weitere Lehrkräfte anfragen" / "Anfragen": adds the teachers to the inquiry and sends them the request */
    static async addSubstitutes(id: Types.ObjectId | string, body: SendReaskWaitingListRequestDto): Promise<MailReportResponseDto> {
        return SubstitutionManagerApi.post(`${id}/add-substitutes`, body, undefined, {handledStatuses: [422]});
    }

    /**
     * "Zusage eintragen" / "Vertretung direkt eintragen" (office): same effect as the confirmation via the link.
     * 409 {message, currentSubstitute} when somebody else is the substitute (then again with replace: true).
     */
    static async manualConfirm(id: Types.ObjectId | string, body: { employee: string; via: 'whatsApp' | 'phone' | 'personal' | 'mail'; note?: string; replace?: boolean;
        sendConfirmation?: boolean })
        : Promise<{ inquiryId: string; replaced?: string; confirmationMessage?: { status: 'sent' | 'skipped' | 'failed'; text?: string } }> {
        return SubstitutionManagerApi.post(`${id}/manual-confirm`, body, undefined, {handledStatuses: [403, 409, 422]});
    }

    static async findById(id: Types.ObjectId, options?: FindByIdOptionsRequestDto): Promise<LeanDocument<SubstitutionInquiryDocument>> {
        return SubstitutionManagerApi.get(id.toString(), options);
    }

    /** Like findById; 403 / 404 (inquiry replaced or withdrawn) are handled by the caller (no global error) */
    static async findByIdHandled(id: Types.ObjectId | string, options?: FindByIdOptionsRequestDto): Promise<LeanDocument<SubstitutionInquiryDocument>> {
        return SubstitutionManagerApi.get(id.toString(), options, undefined, {handledStatuses: [403, 404, 422]});
    }

    /**
     * Configures the cancellation of an inquiry.
     * Newer backends answer 409 if a cancellation was already started/sent; `force` sends it again (`?force=true`).
     * The 409 is handled by the caller (no global error dialog).
     */
    static async cancel(id: Types.ObjectId, body: CancelSubstitutionInquiryRequestDto, options?: { force?: boolean }): Promise<Types.ObjectId> {
        const query = options?.force ? '?force=true' : '';
        return SubstitutionManagerApi.put(`cancel/${id}${query}`, body, {handledStatuses: [409]});
    }

    /**
     * "Automatische Absage stoppen" (right: update cancellationConfig of the inquiry; protocol entry). 409 when nothing
     * can be stopped any more (already started / a confirmation exists) - handled by the caller.
     */
    /** "Nachbereitung" of a past inquiry: what happened, hints (timetable, course logs), what is missing */
    static async followUp(id: Types.ObjectId | string): Promise<SubstitutionFollowUpResponseDto> {
        return SubstitutionManagerApi.get(`${id}/follow-up`, undefined, undefined, {handledStatuses: [403, 404]});
    }

    /** "Was ist passiert?" (+ substitute / note); nothing is sent */
    static async setFollowUp(id: Types.ObjectId | string, body: { outcome?: string | null; substitute?: string | null; note?: string }): Promise<{ inquiryId: string; changed: boolean }> {
        return SubstitutionManagerApi.put(`${id}/follow-up`, body, {handledStatuses: [403, 404, 409, 422]});
    }

    /** "Nachbereitung abgeschlossen" (person + time are stored) */
    static async completeFollowUp(id: Types.ObjectId | string, body: { note?: string } = {}): Promise<{ inquiryId: string; doneAt: string; alreadyDone: boolean }> {
        return SubstitutionManagerApi.post(`${id}/follow-up/done`, body, undefined, {handledStatuses: [403, 404, 409, 422]});
    }

    static async reopenFollowUp(id: Types.ObjectId | string): Promise<{ inquiryId: string }> {
        return SubstitutionManagerApi.post(`${id}/follow-up/reopen`, {}, undefined, {handledStatuses: [403, 404, 409, 422]});
    }

    static async stopAutoCancel(id: Types.ObjectId | string): Promise<{ inquiryId: string; autoCancelStoppedAt: string; alreadyStopped: boolean }> {
        return SubstitutionManagerApi.post(`cancel/${id}/stop-auto`, {}, undefined, {handledStatuses: [403, 404, 409]});
    }

    static async update(id: Types.ObjectId, body: UpdateSubstitutionInquiryRequestDto): Promise<Types.ObjectId> {
        return SubstitutionManagerApi.put(`${id}`, body);
    }

    static async replaceSubstitute(id: Types.ObjectId, body: ReplaceConfirmedSubstituteRequestDto): Promise<Types.ObjectId> {
        return SubstitutionManagerApi.put(`replaceConfirmedSubstitute/${id}`, body);
    }

    static async updateSubstituteConfirmation(id: Types.ObjectId, body: UpdateSubstituteConfirmationRequestDto): Promise<Types.ObjectId> {
        return SubstitutionManagerApi.put(`updateConfirmation/${id}`, body);
    }

    /** "Warteliste erneut anfragen": the chosen waiting substitutes get the "Vertretung wieder frei" message */
    /** "Warteliste erneut anfragen", review flow: rendered mails of the chosen waiting substitutes */
    static async previewReaskWaitingList(id: Types.ObjectId | string, body: PreviewReaskWaitingListMailsRequestDto): Promise<MailDraftsPreviewResponseDto> {
        return SubstitutionManagerApi.post(`reaskWaitingList/${id}/preview`, body);
    }

    /** "Warteliste erneut anfragen": sends the reviewed mails and the WhatsApp messages */
    static async sendReaskWaitingList(id: Types.ObjectId | string, body: SendReaskWaitingListRequestDto): Promise<MailReportResponseDto> {
        return SubstitutionManagerApi.post(`reaskWaitingList/${id}/send`, body);
    }

    /** Manual cancellation with "Prüfen vor dem Senden": rendered mails of one group (families or Standort) */
    static async previewCancellationMails(id: Types.ObjectId | string, body: PreviewCancellationMailsRequestDto): Promise<MailDraftsPreviewResponseDto> {
        return SubstitutionManagerApi.post(`cancel/${id}/preview`, body, undefined, {handledStatuses: [409, 422]});
    }

    /** Sends the pending cancellation: reviewed mails, WhatsApp of the families, completion (409 = already sent) */
    static async sendCancellation(id: Types.ObjectId | string, body: SendCancellationRequestDto): Promise<MailReportResponseDto> {
        return SubstitutionManagerApi.post(`cancel/${id}/send`, body, undefined, {handledStatuses: [409, 422]});
    }

    /** Review flow of the substitution request: rendered mails of the substitutes (contacted by mail) of the inquiries */
    static async previewRequestMails(body: PreviewSubstitutionRequestMailsRequestDto): Promise<MailDraftsPreviewResponseDto> {
        return SubstitutionManagerApi.post('request-mail/preview', body);
    }

    /** Sends the substitution requests of the inquiries (reviewed mails + WhatsApp) and marks them sent */
    static async sendRequests(body: SendSubstitutionRequestsRequestDto): Promise<MailReportResponseDto> {
        return SubstitutionManagerApi.post('request-mail/send', body);
    }

    static async deleteSubstitutionInquiry(id: Types.ObjectId, data: DeleteSubstitutionInquiryRequestDto): Promise<void> {
        return SubstitutionManagerApi.delete(id.toString(), data);
    }
}
